const FavRatingsBeta = () => import(/* webpackChunkName: "PollsFavRatingsBeta" */ "./FavRatingsBeta.vue");

function init_fav_ratings_vue(selector){
    // Start App
    window.fav_ratings_app_beta = new Vue({
        el: selector,
        render: h => h(FavRatingsBeta),
    });
}

function lazy_init_fav_ratings(selector){

    var lazy_init_callback = function(){
        if( window.$(selector) && window.$(selector).inViewport(30) ){
            init_fav_ratings_vue(selector);
            $(window).off("scroll rezise", lazy_init_callback);
        }
    }

    $(window).on('scroll rezise', lazy_init_callback).scroll().resize();
}

function init_fav_ratings_app_beta(){

    var selector = '#fav-ratings-app';

    if( window.$(selector) && window.$(selector).inViewport(30) ){
        init_fav_ratings_vue(selector);
    }else{
        lazy_init_fav_ratings(selector);
    }
}

export default init_fav_ratings_app_beta;